import React from 'react';
import PropTypes from 'prop-types';

const VoterId = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.889 4.66699H22.5557C23.1745 4.66699 23.768 4.94794 24.2056 5.44804C24.6432 5.94814 24.889 6.62641 24.889 7.33366V20.667C24.889 21.3742 24.6432 22.0525 24.2056 22.5526C23.768 23.0527 23.1745 23.3337 22.5557 23.3337H3.889C3.27016 23.3337 2.67667 23.0527 2.23908 22.5526C1.8015 22.0525 1.55566 21.3742 1.55566 20.667V7.33366C1.55566 6.62641 1.8015 5.94814 2.23908 5.44804C2.67667 4.94794 3.27016 4.66699 3.889 4.66699ZM3.889 7.33366V20.667H22.5557V7.33366H3.889ZM14.389 10.0003H20.2223C20.5318 10.0003 20.8285 10.1408 21.0473 10.3908C21.2661 10.6409 21.389 10.98 21.389 11.3337C21.389 11.6873 21.2661 12.0264 21.0473 12.2765C20.8285 12.5265 20.5318 12.667 20.2223 12.667H14.389C14.0796 12.667 13.7828 12.5265 13.564 12.2765C13.3452 12.0264 13.2223 11.6873 13.2223 11.3337C13.2223 10.98 13.3452 10.6409 13.564 10.3908C13.7828 10.1408 14.0796 10.0003 14.389 10.0003ZM14.389 14.0003H20.2223C20.5318 14.0003 20.8285 14.1408 21.0473 14.3908C21.2661 14.6409 21.389 14.98 21.389 15.3337C21.389 15.6873 21.2661 16.0264 21.0473 16.2765C20.8285 16.5265 20.5318 16.667 20.2223 16.667H14.389C14.0796 16.667 13.7828 16.5265 13.564 16.2765C13.3452 16.0264 13.2223 15.6873 13.2223 15.3337C13.2223 14.98 13.3452 14.6409 13.564 14.3908C13.7828 14.1408 14.0796 14.0003 14.389 14.0003ZM6.22233 10.0003H9.72233C10.0318 10.0003 10.3285 10.1408 10.5473 10.3908C10.7661 10.6409 10.889 10.98 10.889 11.3337V15.3337C10.889 15.6873 10.7661 16.0264 10.5473 16.2765C10.3285 16.5265 10.0318 16.667 9.72233 16.667H6.22233C5.91291 16.667 5.61617 16.5265 5.39737 16.2765C5.17858 16.0264 5.05566 15.6873 5.05566 15.3337V11.3337C5.05566 10.98 5.17858 10.6409 5.39737 10.3908C5.61617 10.1408 5.91291 10.0003 6.22233 10.0003Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

VoterId.propTypes = {
  fill: PropTypes.string,
};

export default VoterId;
